import Icon, { IconProps } from '@/components/elements/Icon';
import clsx from 'clsx';

export type ArrowRightProps = IconProps;

/**
 * @component ChartLine
 */
function ArrowRight({ className, ...rest }: ArrowRightProps) {
  return (
    <Icon className={clsx(className)} {...rest}>
      <path
        d="M14.8299 11.2902L10.5899 7.05019C10.497 6.95646 10.3864 6.88207 10.2645 6.8313C10.1427 6.78053 10.012 6.75439 9.87994 6.75439C9.74793 6.75439 9.61723 6.78053 9.49537 6.8313C9.37351 6.88207 9.26291 6.95646 9.16994 7.05019C8.98369 7.23756 8.87915 7.49101 8.87915 7.75519C8.87915 8.01938 8.98369 8.27283 9.16994 8.46019L12.7099 12.0002L9.16994 15.5402C8.98369 15.7276 8.87915 15.981 8.87915 16.2452C8.87915 16.5094 8.98369 16.7628 9.16994 16.9502C9.26338 17.0429 9.3742 17.1162 9.49604 17.166C9.61787 17.2157 9.74834 17.241 9.87994 17.2402C10.0115 17.241 10.142 17.2157 10.2638 17.166C10.3857 17.1162 10.4965 17.0429 10.5899 16.9502L14.8299 12.7102C14.9237 12.6172 14.9981 12.5066 15.0488 12.3848C15.0996 12.2629 15.1257 12.1322 15.1257 12.0002C15.1257 11.8682 15.0996 11.7375 15.0488 11.6156C14.9981 11.4938 14.9237 11.3832 14.8299 11.2902Z"
        fill="#4B5563"
      />
    </Icon>
  );
}

export default ArrowRight;
